let localConfig = {
  locale: 'zh-TW',
  
  view: 'data',
  tab: '',
  searchButtons: {}
}

export default localConfig